
export const defaultSettings = {
    beta: false,
    comment_sort: "top",
    custom_styling: true,
    expand: "condensed",
    expand_thread: true,
    hide_upvoted: false,
    index_profile: false,
    infinite_scroll: true,
    moderates: [],
    new_tab: false,
    notify_comments: true,
    scroll_top: true,
    show_nsfw: true,
    subscribed: [],
    theme: "light",
    topic_nsfw: true,
    topic_other: true,
    topic_politics: false,
    username: "",
    blocked: [],
    active_feed: 1,
    accept_private_messages: true,
    trending_topics: ['Politics', 'NSFW'],
    blocked_communities: [],
};
